@if (transaction(); as transaction) {
  <div class="flex flex-col justify-between relative bg-aml-green-700 -mx-4 px-4 pt-3 min-h-screen menu-custom-scroll overflow-x-hidden">
    <div class="flex flex-col mb-3">
      <img class="mb-3 mt-5 mx-auto" ngSrc="assets/icons/icon-in-transaction.svg" alt="out-transaction" height="60" width="60">
      <h3 class="relative px-[30px] !font-bold !text-[18px] leading-[1.2] mb-3 text-center text-white">
        @if (transaction.type === 'INCOMING') {
          Incoming
        } @else {
          Outgoing
        }
        Transaction
      </h3>
      <div class="mb-1 px-3">
        <p
          class="flex justify-between items-center min-h-[24px] !mb-0 text-[12px]">
          <span class="text-white/70">ID</span>
          <span class="text-white/70">{{ transaction.id }}</span>
        </p>
        <p
          class="flex justify-between items-center min-h-[24px] !mb-0 text-[12px]">
          <span class="text-white/70">Report Time</span>
          <span class="text-white/70">{{ transaction.timeCreated | date: 'HH:mm, dd/MM/yy' }}</span>
        </p>
      </div>

      <div class="bg-white flex flex-col rounded-[8px] shadow-3 border border-solid border-black mb-3">
        <div class="bg-[#F2F4F5] rounded-[6px] py-[9px] px-[11px] flex items-center">
          <img class="w-[30px] h-[30px] mr-[7px]"
              [src]="'assets/icons/currency/' + (transaction.coin | lowercase) + '.svg'" alt="">
          <div class="min-w-[38px] flex flex-col mr-3">
            <span class="leading-[1.2] text-[14px] font-bold mb-1">{{ transaction.coin }}</span>
            <span class="text-[11px] leading-[1.2] ">{{ transaction.network | convertNetworkToToken }}</span>
          </div>
          <div class="flex flex-col mr-3">
            <span class="text-[12px] leading-[1.2] mb-1 mt-[1px]">Sender:</span>
            <span class="flex items-center pt-[1px]">
              <span
                class="text-[#7A9095] text-[14px] leading-[1] mr-1">{{ transaction.addressFrom | cropWithDotsCenter: 6 : 6 }}</span>
              <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" [value]="transaction.addressFrom"
                              [size]="'small'"></app-copy-button>
            </span>
          </div>
        </div>
        <div class="flex justify-start py-3 pr-3 pl-4 bg-[#FFE5E5]">
          <img class="mr-[15px]" ngSrc="assets/icons/arrow-down-new.svg" alt="arrow" height="78" width="18">
          <div class="flex flex-col">
            <span class="text-[12px] leading-[1.2]">Amount Received:</span>
            <span class="leading-[1.2] text-[26px] tracking-[-0.45px] font-medium mb-2">
              @if (transaction.coin === 'USDT') {
                {{ (transaction.amount | cutNumber:('1.2-2')) ?? '0.00' }}
              } @else {
                {{ (transaction.amount | cutNumber:('1.2-8')) ?? '0.00' }}
              }
              {{ transaction.coin }}
            </span>
            <span class="text-[#7A9095] text-[12px] leading-[1.2] mb-[2px]">Hash:</span>
            <span class="flex items-center">
              <span
                class="text-[#7A9095] text-[14px] leading-[1]">{{ transaction.target | cropWithDotsCenter:14:14 }}</span>
              <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" class="ml-1" [value]="transaction.target"
                              [size]="'small'"></app-copy-button>
            </span>
          </div>
        </div>
        <div class="bg-[#F2F4F5] rounded-[6px] py-[9px] px-[11px] flex items-center">
          <img class="w-[30px] h-[30px] mr-[7px]"
              [src]="'assets/icons/currency/' + (transaction.coin | lowercase) + '.svg'" alt="">
          <div class="min-w-[38px] flex flex-col mr-3">
            <span class="leading-[1.2] text-[14px] font-bold mb-1">{{ transaction.coin }}</span>
            <span class="text-[11px] leading-[1.2] ">{{ transaction.network | convertNetworkToToken }}</span>
          </div>
          <div class="flex flex-col mr-3">
            <span class="flex text-[12px] leading-[1.2] mb-1 mt-[1px]">
              <span class="mr-3">Receiver:</span>
              @if (transaction.type === 'INCOMING') {
                <span class="font-bold">My wallet: {{ transaction.walletName }}</span>
              }
            </span>
            <span class="flex items-center pt-[1px]">
              <span
                class="text-[#7A9095] leading-[1] text-[14px] mr-1">{{ transaction.addressTo | cropWithDotsCenter:10:10 }}</span>
              <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" [value]="transaction.addressTo"
                              [size]="'small'"></app-copy-button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
}
